<template>
  <div :class="{ topBox: true, noScroll: isScroll }">
    <div class="top">
      <div class="topTitle"></div>
      <ul>
        <li>
          <router-link to="/HomePage">首页</router-link>
        </li>
        <li>
          <router-link to="/GamePage">Game 2024</router-link>
        </li>
        <li>
          <router-link to="/PreviousPage">往届链接</router-link>
        </li>
        <li>
          <a @click="dialogIsShow">注册/登录</a>
        </li>
      </ul>
      <div class="title"></div>
      <div class="sTitle"></div>
      <div class="logo"></div>
    </div>
    <div>
      <router-view></router-view>
    </div>

    <div v-if="isShow">
      <div class="black"></div>
      <div class="dialog">
        <div class="dialog_title">登录</div>
        <div class="dialog_cha" @click="dialogIsntShow"></div>

        <div class="content">
          <input
            type="text"
            name="telephone"
            id="telephone"
            placeholder="请输入您的邮箱"
          />
          <div class="tips">
            <i> </i>
            <p>
              没有账号？立即
              <span style="color: #ff4141; cursor: pointer" @click="go_register"
                >注册</span
              >
            </p>
          </div>
          <input
            type="password"
            name="password"
            id="password"
            placeholder="请输入您的密码"
          />
          <!-- <input type="code" name="code" id="code" placeholder="验证码" />
          <button
            class="getCode"
            @click="getCodeFn"
            v-html="codeHtml"
            :disabled="codeBtnISabled"
          ></button> -->
          <button class="loginBtn">登录</button>
        </div>
      </div>
    </div>

    <div v-if="isShow_register">
      <div class="black_register"></div>
      <div class="dialog_register">
        <div class="dialog_title_register">注册</div>
        <div class="dialog_cha_register" @click="dialogIsntShow_register"></div>

        <div class="content_register">
          <input
            type="text"
            name="telephone"
            id="telephone_register"
            placeholder="请输入您的邮箱"
          />
          <div class="tips_register"></div>
          <input
            type="password"
            name="password"
            id="password_register"
            placeholder="请输入您的密码"
          />
          <input
            type="password"
            name="password_enter"
            id="password_register_enter"
            placeholder="确认密码"
          />
          <!-- <input type="code" name="code" id="code" placeholder="验证码" />
          <button
            class="getCode"
            @click="getCodeFn"
            v-html="codeHtml"
            :disabled="codeBtnISabled"
          ></button> -->
          <button class="loginBtn_register">注册</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      screenHeight: 0,
      isScroll: false,
      isShow: false,
      codeHtml: '发送验证码',
      codeBtnISabled: false,
      isShow_register: false
    }
  },
  methods: {
    updateScreenHeight () {
      this.screenHeight = window.innerHeight
      // if (document.querySelector('.noScroll').style.height === undefined) return
      // document.querySelector('.noScroll').style.height =
      //   this.screenHeight - 1 + 'px'
    },
    dialogIsShow () {
      this.isShow = true
    },
    dialogIsntShow () {
      this.isShow = false
    },
    getCodeFn () {
      this.codeBtnISabled = true
      let i = 59
      this.codeHtml = '重新获取：60'
      const timer = setInterval(() => {
        this.codeHtml = `重新获取：${i--}`
        if (i === -1) {
          clearInterval(timer)
          this.codeBtnISabled = false
          this.codeHtml = '获取验证码'
        }
      }, 1000)
    },
    dialogIsntShow_register () {
      this.isShow_register = false
    },
    go_register () {
      this.isShow = false
      this.isShow_register = true
    }
  },
  mounted () {
    // 添加事件监听来获取新的屏幕高度
    window.addEventListener('resize', this.updateScreenHeight)
    // 初始调用获取初始屏幕高度
    this.updateScreenHeight()
    // console.log(this.updateScreenHeight())
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTZCHK";
  src: url("/src/assets/font/FZLTCHJW.TTF") format("truetype"); /* 使用webpack的别名&#126;@指向src目录 */
  font-weight: normal;
  font-style: normal;
}
a {
  text-decoration: none;
}
.topBox {
  width: 100%;
  .top {
    position: relative;
    width: 100%;
    height: 7.29rem;
    background: url(/src/assets/img/topBg.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    min-width: var(--content-width);
    .topTitle {
      position: absolute;
      top: 0.32rem;
      left: 3rem;
      width: 2rem;
      height: 0.29rem;
      background: url(/src/assets/img/Transportation.png) no-repeat;
      background-size: contain;
    }
    ul {
      // height: 0.8rem;
      position: absolute;
      top: 0.2rem;
      // padding-top: 0.3rem;
      right: 2.84rem;
      display: flex;
      list-style: none;
      li {
        margin: 0.2rem 0.1rem;
        font-family: FZLTZCHK;
        cursor: pointer;
        font-size: 0.12rem;
        a {
          font-weight: normal;
          // color: #1d1d1d;
          // line-height: 0.2rem;
          padding: 0.04rem 0.1rem;
        }
      }
    }
  }
  // active类
  .myClassActive {
    // overflow: hidden;
    color: #5d4df6;
    background: linear-gradient(
      0deg,
      rgba(137, 247, 254, 0.6) 0%,
      rgba(102, 166, 255, 0.6) 100%
    );
    border-radius: 0.18rem;
    border: 0.02rem solid;
    border-image: linear-gradient(0deg, #4facfe, #00f2fe);
  }
  // 标题
  .title {
    position: relative;
    top: 3.1rem;
    left: 3rem;
    width: 6.92rem;
    height: 0.6rem;
    background: url(/src/assets/img/title.png) no-repeat;
    background-size: contain;
  }
  .sTitle {
    position: relative;
    top: 3.46rem;
    left: 3rem;
    width: 4.87rem;
    height: 0.33rem;
    background: url(/src/assets/img/sTitle.png) no-repeat;
    background-size: contain;
  }
  .logo {
    position: relative;
    top: 1.18rem;
    left: 9.95rem;
    height: 3.18rem;
    width: 3.13rem;
    background: url(/src/assets/img/logo.png) no-repeat;
    background-size: contain;
  }
}

// 弹框控制
.dialog {
  height: 65%;
  width: 80%;
  max-height: 8rem;
  background-color: #fff;
  z-index: 3;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .content {
    position: relative;
    height: 100%;
    width: 100%;
    // background-color: pink;
    margin: 0 auto;
  }
  .dialog_title {
    font-size: 0.5rem;
    font-family: FZLTZCHK;
    padding-top: 0.5rem;
    padding-left: 0.5rem;
  }

  #telephone {
    position: absolute;
    top: 10%;
    width: 7rem;
    height: 1rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.3rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, -30%);
  }
  #password {
    position: absolute;
    top: 10%;
    width: 7rem;
    height: 1rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.3rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, 200%);
  }
  .tips {
    i {
      position: absolute;
      top: 25%;
      left: 20%;
      background: url(/src/assets/img/tips.png) no-repeat;
      background-size: 100% 100%;
      height: 0.4rem;
      width: 0.4rem;
    }
    p {
      position: absolute;
      top: 27%;
      left: 15%;
      font-size: 0.26rem;
      margin-left: 1.47rem;
      margin-top: -0.07rem;
      color: #595959;
      font-family: FZLTZCHK;
    }
  }
  #code {
    position: absolute;
    top: 40%;
    left: 18.9%;
    width: 3.5rem;
    height: 1rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.3rem;
    color: #595959;
    padding: 0 0.3rem;
  }
  .getCode {
    position: absolute;
    width: 3.2rem;
    height: 1rem;
    top: 40%;
    left: 55%;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #fff;
    background-color: #74b9ff;
    border-radius: 0.08rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0;
    cursor: pointer;
  }
  .loginBtn {
    position: absolute;
    width: 7.7rem;
    height: 1rem;
    top: 65%;
    left: 18.9%;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #fff;
    background-color: #74b9ff;
    border-radius: 0.08rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0;
    cursor: pointer;
  }
}
.black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.dialog_cha {
  position: absolute;
  top: 0.55rem;
  right: 0.5rem;
  height: 0.5rem;
  width: 0.5rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}

// 禁止滚动
.noScroll {
  overflow-y: hidden;
}

// 登录弹框控制
.dialog_register {
  height: 65%;
  width: 80%;
  max-height: 8rem;
  background-color: #fff;
  z-index: 3;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .content_register {
    position: relative;
    height: 100%;
    width: 100%;
    // background-color: pink;
    margin: 0 auto;
  }
  .dialog_title_register {
    font-size: 0.5rem;
    font-family: FZLTZCHK;
    padding-top: 0.5rem;
    padding-left: 0.5rem;
  }

  #telephone_register {
    position: absolute;
    top: 10%;
    width: 7rem;
    height: 1rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.3rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, -30%);
  }
  #password_register {
    position: absolute;
    top: 10%;
    width: 7rem;
    height: 1rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.3rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, 100%);
  }
  #password_register_enter {
    position: absolute;
    top: 10%;
    width: 7rem;
    height: 1rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.3rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, 230%);
  }
  .tips_register {
    i {
      position: absolute;
      top: 25%;
      left: 20%;
      background: url(/src/assets/img/tips.png) no-repeat;
      background-size: 100% 100%;
      height: 0.4rem;
      width: 0.4rem;
    }
    p {
      position: absolute;
      top: 27%;
      left: 15%;
      font-size: 0.26rem;
      margin-left: 1.47rem;
      margin-top: -0.07rem;
      color: #595959;
      font-family: FZLTZCHK;
    }
  }

  .loginBtn_register {
    position: absolute;
    width: 7.7rem;
    height: 1rem;
    top: 65%;
    left: 18.9%;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #fff;
    background-color: #74b9ff;
    border-radius: 0.08rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0;
    cursor: pointer;
  }
}
.black_register {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.dialog_cha_register {
  position: absolute;
  top: 0.55rem;
  right: 0.5rem;
  height: 0.5rem;
  width: 0.5rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}
</style>
